export default function NumberFormat(v) {
  return new Intl.NumberFormat("ru-RU", {
    currency: "GEL",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(v);
}
